import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { LoginDetail } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  login(user: string, pass: string): Observable<LoginDetail> {
    const params = new HttpParams()
      .append('user', user)
      .append('pass', pass);

    return this.http.post<LoginDetail>(environment.baseUrl + 'public/login', params);
  }

  resetPassword(oldPass: string, newPass: string): Observable<LoginDetail> {
    const params = new HttpParams()
      .append('oldpass', oldPass)
      .append('newpass', newPass);

    return this.http.post<LoginDetail>(environment.baseUrl + 'account/reset-password', params);
  }
}
